/**
 * Core Supabase client service with session-aware configuration
 */
import { supabase } from '@/integrations/supabase/client';
import { createAuthenticatedClient } from '@/hooks/useSupabaseClient';

// Get the current session token from localStorage or sessionStorage
const getSessionToken = (): string | null => {
  try {
    const stored = localStorage.getItem('agxl_session') || sessionStorage.getItem('agxl_session');
    if (stored) {
      const session = JSON.parse(stored);
      return session.accessToken || null;
    }
  } catch {
    return null;
  }
  return null;
};

// Get an authenticated client for the current session
export const getAuthenticatedClient = () => {
  const token = getSessionToken();
  if (token) {
    return createAuthenticatedClient(token);
  }
  return supabase;
};

// Supabase project configuration
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://glyelurvdvrbqeyklseh.supabase.co';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdseWVsdXJ2ZHZyYnFleWtsc2VoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk0NDQzNzEsImV4cCI6MjA4NTAyMDM3MX0._fB90EOfQdF-E-96BLpldcAYlrsU-7P9Tvl-B6bDV4s';

// Get user ID from current session
export const getCurrentUserId = (): string | null => {
  try {
    const stored = localStorage.getItem('agxl_session') || sessionStorage.getItem('agxl_session');
    if (stored) {
      const session = JSON.parse(stored);
      return session.userId || null;
    }
  } catch {
    return null;
  }
  return null;
};

// Export the base client
export { supabase };
